
import { AllCompGUID } from '../sgiConstants/SgiCompConstant';
import { SgiCalendarEO } from '../sgiCompEO/SgiCalendarEO';
import { SgiCollapseEO } from '../sgiCompEO/SgiCollapseEO';
import { SgiCommEchartsEO } from '../sgiCompEO/SgiCommEchartsEO';
import { SgiDVEO } from '../sgiCompEO/SgiDVEO';
import { SgiEChartsCommonEO } from '../sgiCompEO/SgiEChartsCommonEO';
import { SgiFormCascaderEO } from '../sgiCompEO/SgiFormCascaderEO';
import { SgiFormCheckboxEO } from '../sgiCompEO/SgiFormCheckboxEO';
import { SgiFormCheckboxGroupEO } from '../sgiCompEO/SgiFormCheckboxGroupEO';
import { SgiFormComboboxEO } from '../sgiCompEO/SgiFormComboboxEO';
import { SgiFormComboxTreeEO } from '../sgiCompEO/SgiFormComboxTreeEO';
import { SgiFormEditorEO } from '../sgiCompEO/SgiFormEditorEO';
import { SgiFormEO } from '../sgiCompEO/SgiFormEO';
import { SgiFormFileEO } from '../sgiCompEO/SgiFormFileEO';
import { SgiFormPopUIEO } from '../sgiCompEO/SgiFormPopUIEO';
import { SgiFormRadioEO } from '../sgiCompEO/SgiFormRadioEO';
import { SgiImgEO } from '../sgiCompEO/SgiImgEO';
import { SgiLabelEO } from '../sgiCompEO/SgiLabelEO';
import { SgiTagEO } from '../sgiCompEO/SgiTagEO';
import { SgiListEO } from '../sgiCompEO/SgiListEO';
import { SgiMenuEO } from '../sgiCompEO/SgiMenuEO';
import { SgiNestEO } from '../sgiCompEO/SgiNestEO';
import { SgiOverlapEO } from '../sgiCompEO/SgiOverlapEO';
import { SgiPanelEO } from '../sgiCompEO/SgiPanelEO';
import { SgiRowEO } from '../sgiCompEO/SgiRowEO';
import { SgiColEO } from '../sgiCompEO/SgiColEO';
import { SgiSplitterEO } from '../sgiCompEO/SgiSplitterEO';
import { SgiStepsEO } from '../sgiCompEO/SgiStepsEO';
import { SgiTableEO } from '../sgiCompEO/SgiTableEO';
import { SgiTabsEO } from '../sgiCompEO/SgiTabsEO';
import { SgiTileEO } from '../sgiCompEO/SgiTileEO';
import { SgiToolbarEO } from '../sgiCompEO/SgiToolbarEO';
import { SgiTransferEO } from '../sgiCompEO/SgiTransferEO';
import { SgiTreeEO } from '../sgiCompEO/SgiTreeEO';
import { SgiTVEO } from '../sgiCompEO/SgiTVEO';
import { SgiButtonEO } from './SgiButtonEO';
import { SgiCardEO } from './SgiCardEO';
import { SgiFormDateEO } from './SgiFormDateEO';
import { SgiFormInputNumberEO } from './SgiFormInputNumberEO';
import { SgiFormTextAreaEO } from './SgiFormTextAreaEO';
import { SgiFormTextEO } from './SgiFormTextEO';
import { SgiFormTimeEO } from './SgiFormTimeEO';
import { uuid, copy, jsonToStr } from "../sgiCommon/sgiCommon";

var sgiCreateEO = function (mdType, type) {
    let sgiCompDesc;
    if (mdType && mdType == AllCompGUID.FIELDTEXT) {
        sgiCompDesc = SgiFormTextEO();  //文本域    
    } else if (mdType && mdType == AllCompGUID.TEXTAREA) {
        sgiCompDesc = SgiFormTextAreaEO();  //数字控件    
    } else if (mdType && mdType == AllCompGUID.NUMBER) {
        sgiCompDesc = SgiFormInputNumberEO();  //日期控件    
    } else if (mdType && mdType == AllCompGUID.DATE) {
        sgiCompDesc = SgiFormDateEO();  //时间控件    
    } else if (mdType && mdType == AllCompGUID.TIME) {
        sgiCompDesc = SgiFormTimeEO();  //文件控件    
    } else if (mdType && mdType == AllCompGUID.UPLOADFILE) {
        sgiCompDesc = SgiFormFileEO();  //下拉窗控件    
    } else if (mdType && mdType == AllCompGUID.COMBOBOX) {
        sgiCompDesc = SgiFormComboboxEO();  //复选框控件    
    } else if (mdType && mdType == AllCompGUID.CHECKBOX) {
        sgiCompDesc = SgiFormCheckboxEO();  //复选框组件    
    } else if (mdType && mdType == AllCompGUID.CHECKBOXGROUP) {
        sgiCompDesc = SgiFormCheckboxGroupEO();  //级联控件    
    } else if (mdType && mdType == AllCompGUID.CHECKBOXGROUP) {
        sgiCompDesc = SgiFormCascaderEO();
    } else if (mdType && mdType == AllCompGUID.CASCADER) {
        sgiCompDesc = SgiFormCascaderEO();  //单选框组件    
    } else if (mdType && mdType == AllCompGUID.RADIOGROUP) {
        sgiCompDesc = SgiFormRadioEO();  //弹出窗控件    
    } else if (mdType && mdType == AllCompGUID.POPUI) {
        sgiCompDesc = SgiFormPopUIEO();  //富文本控件    
    } else if (mdType && mdType == AllCompGUID.EDITOR) {
        sgiCompDesc = SgiFormEditorEO();  //下拉树控件    
    } else if (mdType && mdType == AllCompGUID.COMBOXTREE) {
        sgiCompDesc = SgiFormComboxTreeEO();  //Dnd_SgiToolbar
    } else if (mdType && mdType == AllCompGUID.TOOLBAR) {
        sgiCompDesc = SgiToolbarEO();  //Dnd_SgiButton
    } else if (mdType && mdType == AllCompGUID.BUTTON) {
        sgiCompDesc = SgiButtonEO();  //Dnd_SgiImg 图片
    } else if (mdType && mdType == AllCompGUID.IMG) {
        sgiCompDesc = SgiImgEO();  //Dnd_SgiList 列表
    } else if (mdType && mdType == AllCompGUID.LIST) {
        sgiCompDesc = SgiListEO();  //Dnd_SgiLabel 标签
    } else if (mdType && mdType == AllCompGUID.LABEL) {
        sgiCompDesc = SgiLabelEO();  //tag
    } else if (mdType && mdType == AllCompGUID.TAG) {
        sgiCompDesc = SgiTagEO();  //树面板
    } else if (mdType && mdType == AllCompGUID.TREE) {
        sgiCompDesc = SgiTreeEO();  //表格面板
    } else if (mdType && mdType == AllCompGUID.TABLE) {
        sgiCompDesc = SgiTableEO();  //tv
    } else if (mdType && mdType == AllCompGUID.TV) {
        sgiCompDesc = SgiTVEO();      //穿梭框
    } else if (mdType && mdType == AllCompGUID.TRANSFER) {
        sgiCompDesc = SgiTransferEO();      //嵌入面板
    } else if (mdType && mdType == AllCompGUID.NEST) {
        sgiCompDesc = SgiNestEO();      //form
    } else if (mdType && mdType == AllCompGUID.WV) {
        sgiCompDesc = SgiFormEO();      //panel
    } else if (mdType && mdType == AllCompGUID.PANEL) {
        sgiCompDesc = SgiPanelEO();      //重叠面板
    } else if (mdType && mdType == AllCompGUID.CARD) {
        sgiCompDesc = SgiCardEO();      //新重叠面板
    } else if (mdType && mdType == AllCompGUID.OVERLAP) {
        sgiCompDesc = SgiOverlapEO();      //折叠面板
    } else if (mdType && mdType == AllCompGUID.ACCORDION) {
        sgiCompDesc = SgiCollapseEO();      //tab
    } else if (mdType && mdType == AllCompGUID.TAB) {
        sgiCompDesc = SgiTabsEO();      //分割面板
    } else if (mdType && mdType == AllCompGUID.SPLITTER) {
        sgiCompDesc = SgiSplitterEO();      //菜单组件
    } else if (mdType && mdType == AllCompGUID.MENU) {
        sgiCompDesc = SgiMenuEO();      //步骤组件
    } else if (mdType && mdType == AllCompGUID.STEP) {
        sgiCompDesc = SgiStepsEO();      // ECharts图表-自定义图表
    } else if (mdType && mdType == AllCompGUID.EC_COMMON) {
        sgiCompDesc = SgiEChartsCommonEO();      // 平铺组件
    } else if (mdType && mdType == AllCompGUID.Tile) {
        sgiCompDesc = SgiTileEO();      // 通用图表
    } else if (mdType && mdType == AllCompGUID.CommEcharts) {
        sgiCompDesc = SgiCommEchartsEO();      // 日历
    } else if (mdType && mdType == AllCompGUID.Calendar) {
        sgiCompDesc = SgiCalendarEO();
    } else if (mdType && mdType == AllCompGUID.DV) {
        sgiCompDesc = SgiDVEO();
        //布局这个比较特殊，单独处理json结构
    } else if (mdType && mdType == AllCompGUID.LT_ROW) {
        if (type && type === 'row24') {
            sgiCompDesc = SgiRowEO();
            let sgicolDesc = SgiColEO();
            sgicolDesc.span = 24;
            sgicolDesc.dnd_id = 'id_' + uuid(8);
            sgiCompDesc.cldSet = [sgicolDesc];
        } else if (type && type === 'row12+12') {
            sgiCompDesc = SgiRowEO();
            let sgicolDesc1 = SgiColEO();
            let sgicolDesc2 = SgiColEO();
            sgicolDesc1.span = 12;
            sgicolDesc2.span = 12;
            sgicolDesc1.dnd_id = 'id_' + uuid(8);
            sgicolDesc2.dnd_id = 'id_' + uuid(8);
            sgiCompDesc.cldSet = [sgicolDesc1, sgicolDesc2];
        } else if (type && type === 'row16+8') {
            sgiCompDesc = SgiRowEO();
            let sgicolDesc1 = SgiColEO();
            let sgicolDesc2 = SgiColEO();
            sgicolDesc1.span = 16;
            sgicolDesc2.span = 8;
            sgicolDesc1.dnd_id = 'id_' + uuid(8);
            sgicolDesc2.dnd_id = 'id_' + uuid(8);
            sgiCompDesc.cldSet = [sgicolDesc1, sgicolDesc2];

        } else if (type && type === 'row8+8+8') {
            sgiCompDesc = SgiRowEO();
            let sgicolDesc1 = SgiColEO();
            let sgicolDesc2 = SgiColEO();
            let sgicolDesc3 = SgiColEO();
            sgicolDesc1.span = 8;
            sgicolDesc2.span = 8;
            sgicolDesc3.span = 8;
            sgicolDesc1.dnd_id = 'id_' + uuid(8);
            sgicolDesc2.dnd_id = 'id_' + uuid(8);
            sgicolDesc3.dnd_id = 'id_' + uuid(8);
            sgiCompDesc.cldSet = [sgicolDesc1, sgicolDesc2, sgicolDesc3];

        } else if (type && type === 'row4+12+8') {
            sgiCompDesc = SgiRowEO();
            let sgicolDesc1 = SgiColEO();
            let sgicolDesc2 = SgiColEO();
            let sgicolDesc3 = SgiColEO();
            sgicolDesc1.span = 4;
            sgicolDesc2.span = 12;
            sgicolDesc3.span = 8;
            sgicolDesc1.dnd_id = 'id_' + uuid(8);
            sgicolDesc2.dnd_id = 'id_' + uuid(8);
            sgicolDesc3.dnd_id = 'id_' + uuid(8);
            sgiCompDesc.cldSet = [sgicolDesc1, sgicolDesc2, sgicolDesc3];
        } else if (type && type === 'row6+6+6+6') {
            sgiCompDesc = SgiRowEO();
            let sgicolDesc1 = SgiColEO();
            let sgicolDesc2 = SgiColEO();
            let sgicolDesc3 = SgiColEO();
            let sgicolDesc4 = SgiColEO();
            sgicolDesc1.span = 6;
            sgicolDesc2.span = 6;
            sgicolDesc3.span = 6;
            sgicolDesc4.span = 6;
            sgicolDesc1.dnd_id = 'id_' + uuid(8);
            sgicolDesc2.dnd_id = 'id_' + uuid(8);
            sgicolDesc3.dnd_id = 'id_' + uuid(8);
            sgicolDesc4.dnd_id = 'id_' + uuid(8);
            sgiCompDesc.cldSet = [sgicolDesc1, sgicolDesc2, sgicolDesc3, sgicolDesc4];
        } else {
            sgiCompDesc = SgiRowEO();
        }
    } else if (mdType && mdType == AllCompGUID.LT_COL) {//列组件  
        sgiCompDesc = SgiColEO();
    }
    sgiCompDesc.dnd_id = 'id_' + uuid(8);
    return sgiCompDesc;
}

export { sgiCreateEO };
export default sgiCreateEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiCreateEO.js